export default function Contact() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            投稿、合作、反馈 — 海角网期待你的声音
          </p>

          <div className="mt-8 bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-center">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900">投稿邮箱</h3>
                <a
                  href="#contact"
                  onClick={handleClick}
                  className="mt-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  contribute@haijiao.com
                </a>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-customer-service-2-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900">客服支持</h3>
                <a
                  href="#contact"
                  onClick={handleClick}
                  className="mt-1 text-sm text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
                >
                  support@haijiao.com
                </a>
              </div>

              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-links-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900">商务合作</h3>
                <a
                  href="#contact"
                  onClick={handleClick}
                  className="mt-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  business@haijiao.com
                </a>
              </div>
            </div>
          </div>

          <p className="mt-6 text-xs text-foreground-400">
            也可通过海角社区站内信直接联系管理员，工作日 24 小时内回复
          </p>
        </div>
      </div>
    </section>
  );
}